<div class="reminder-item ui-g p-zero">
  <div class="ui-g-4 pl-0">
    <app-dropdown idKey="value" field="title" position="top" theme="inline-border-bottom" itemWidth="100px"
      scrollHeight="100px" [options]="frequencys" [value]="reminderTime.frequency" [setPositionDynamically]="false"
      [isDropdownIconVisible]="false" [focusOnSelectedValue]="true" [fontSize]="10"
      (appSelect)="handleSelect('frequency', $event)">
    </app-dropdown>
  </div>

  <div class="ui-g-4 pl-0">
    <app-dropdown idKey="value" itemWidth="100px" field="title" position="top" scrollHeight="100px"
      theme="inline-border-bottom" [options]="keys" [value]="reminderTime.period" [setPositionDynamically]="false"
      [isDropdownIconVisible]="false" [focusOnSelectedValue]="true" [fontSize]="10"
      (appSelect)="handleSelect('period', $event)">
    </app-dropdown>
  </div>

  <div class="ui-g-4 reminder-label flex-start-center pl-0">
    <span class="font-10 mr-1">Before</span>
    <i (click)="deleteReminder()" class="fas fa-trash font-gray font-11 pointer"></i>
  </div>
</div>
